export const AUTO_STATUS = {
  scheduled: ["Scheduled", "border-sky-400/40 text-sky-300"],
  sent: ["Sent", "border-emerald-400/40 text-emerald-300"],
  reviewed: ["Reviewed", "border-[var(--gold)] text-gold"],
  reminder_sent: ["Reminder Sent", "border-violet-300/40 text-violet-200"],
  canceled: ["Canceled", "border-white/20 text-slate-400"],
};

export const AutoStatusPill = ({ status, testid }) => {
  const [label, cls] = AUTO_STATUS[status] || [status || "None", "border-white/15 text-slate-400"];
  return <span className={`px-2 py-1 border text-[0.65rem] font-mono uppercase ${cls}`} data-testid={testid}>{label}</span>;
};
